import React from "react";

const DetailPopup = ({ selectedMember, onClose,popup_background_color,popup_text_color,popup_links_color, }) => {
    if (!selectedMember) return null;

    return (
        <div className="team_showcase_modal_overlay" onClick={onClose}>
            <div className="team_showcase_modal" onClick={(e) => e.stopPropagation()} style={{ backgroundColor: popup_background_color }}>
                <button className="modal_close_btn" onClick={onClose}>×</button>
                <div className="modal_content">
                    {selectedMember.image && (
                        <img src={selectedMember.image} alt={selectedMember.name} />
                    )}
                    {selectedMember.name && (
                        <h3 style={{color: popup_text_color }}>{selectedMember.name}</h3>
                    )}
                    {selectedMember.position && (
                        <p style={{color: popup_text_color }}>{selectedMember.position}</p>
                    )}
                    {selectedMember.email && (
                        <p style={{color: popup_links_color }}><a href={`mailto:${selectedMember.email}`}>{selectedMember.email}</a></p>
                    )}
                    {selectedMember.phone && (
                        <p style={{color: popup_links_color }}>
                            <a href={`tel:${selectedMember.phone}`} style={{ color: popup_links_color, textDecoration: 'none' }}>
                                {selectedMember.phone}
                            </a>
                        </p>
                    )}
                    {selectedMember.location && (
                        <p style={{color: popup_links_color }}>{selectedMember.location}</p>
                    )}
                    {selectedMember.website && (
                        <p><a href={selectedMember.website} target="_blank" rel="noopener noreferrer">{selectedMember.website}</a></p>
                    )}
                    {selectedMember.description && (
                        <p style={{color: popup_text_color }}>{selectedMember.description}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DetailPopup;
